import React from 'react';
import { PolicyContainer } from './components/Policy/container';
import './styles/components/Policy.css';

const PolicyApp: React.FC = () => {
    return (
        <React.Fragment>
            <PolicyContainer />
        </React.Fragment>
    );
}

export default PolicyApp;